/** Способ закрытия окна пользователем. */
export type ModalCloseReason = 'escape' | 'outside' | 'close-button';

/** Случайное закрытие — Escape или щелчок по фону: при несохранённом вводе сначала вопрос. Крестик и кнопки окна
 *  закрывают сразу. */
export const isAccidentalClose = (reason: unknown): reason is 'escape' | 'outside' =>
    reason === 'escape' || reason === 'outside';
